<div class="grid">
    <eon-ui-preloader-circle/>
</div>
